
import { Component, Vue } from "vue-property-decorator";
import { PDropDownContainer } from "@/common/components";
import { PRow } from "@/common/components/look/PRow";
import PIcon from "@/common/components/look/PIcon/PIcon.vue";
import SupportDropDownActualId from "./SupportDropDownActualId.vue";

@Component({
  name: "support-actual-id-filter",
  components: {
    PRow,
    PIcon,
    PDropDownContainer,
    SupportDropDownActualId,
  },
})
export default class SupportActualIdFilter extends Vue {}
